export class VersionImplementation {
  
  static singleInstance:VersionImplementation;
  universalService: any;
  http: any;
  customMetadata: any;
  versionsList = [];
  constructor(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
  }

  public static getInstance(globalService):VersionImplementation{
		if(this.singleInstance == null){
			this.singleInstance = new VersionImplementation(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
  }

  public setHandler(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
    this.http = globalService.getHttpClientRef();
    this.customMetadata = globalService.getCustomMetadataServiceRef();
  }



  getVersionsForFile(url){
    var self = this;
    this.resetData();
    return new Promise(function(resolve,reject){
      self.http.get(url).subscribe(
          suc=>{
            suc["totalVersions"] = (suc["totalVersions"] < 10 && suc["totalVersions"].toString().length == 1) ? "0"+suc["totalVersions"] : suc["totalVersions"];
            self.toggleLoader(false)
            self.setMetadataForVersioning(suc);
            resolve(suc)
          },
          err=>{
              self.toggleLoader(false);
              console.log("error in fetching versions",err);
              self.setMetadataForVersioning({"objVersions":[],"totalVersions":0});
              self.universalService.showToast(err["error"]["error"],"error")
              reject(err)
          }
      )
  })
  }

  deleteSelectedVersionOfTheFile(url,metadata,selectedVersionToDelete){
      var self = this;
      var payload = {
        "objectKey":metadata["objectKey"],
        "version":selectedVersionToDelete["version"]
      }
      return new Promise(function(resolve,reject){
        self.http.put(url,payload).subscribe(
            suc=>{
              self.toggleLoader(false)
              self.setMetadataForVersioning(suc);
              resolve({"deleted version":true,"response":suc})
            },
            err=>{
                self.toggleLoader(false);
                console.log("error in deleting version",err);
                self.universalService.showToast(err["error"]["error"],"error")
                reject({"deleted version":false,"error":err["error"]["error"]})
            }
        )
    })
  }


  restoreSelectedVersionOfTheFile(url,metadata,selectedVersionToDelete){
    var self = this;
    var payload = {
      "objectKey":metadata["objectKey"],
      "version":selectedVersionToDelete["version"]
    }
    return new Promise(function(resolve,reject){
      self.http.put(url,payload).subscribe(
          suc=>{
            self.toggleLoader(false)
            self.setMetadataForVersioning(suc);
            resolve({"restored version":true,"response":suc})
          },
          err=>{
              self.toggleLoader(false);
              console.log("error in restoring version",err);
              self.universalService.showToast(err["error"]["error"],"error")
              reject({"restored version":false,"error":err["error"]["error"]})
          }
      )
  })
}

  setMetadataForVersioning(data){
    var self = this;
    this.versionsList = data;
    var d;
    this.versionsList["objVersions"].map(obj=>{
      // if(obj["isCurrentVersion"]){
        d = new Date(obj["lastUpdatedDate"])
      // }else{
      //   d = new Date(obj["createdDate"])
      // }
      obj["versionCreatedBy"] = obj["versionCreatedBy"] ? obj["versionCreatedBy"] : {};
      obj["versionCreatedBy"]["firstName"] = obj["versionCreatedBy"]["firstName"] ? obj["versionCreatedBy"]["firstName"] : "-";
      obj["versionCreatedBy"]["lastName"] = obj["versionCreatedBy"]["lastName"] ? obj["versionCreatedBy"]["lastName"] : "";
      obj["customCreatedDate"] = self.setDateAMPM(d);
    })
  }


  resetData(){
    this.versionsList = [];
  }

  toggleLoader(show){
    if(show) {
      $(".spinner_loader").show();
    } else {
      $(".spinner_loader").hide();
    }
  }


  setDateAMPM(date){
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return this.universalService.LONG_MONTH_NAMES[date.getMonth()] + " " + date.getDate() + " " + date.getFullYear() + ", " + strTime;
  }
}